import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Sidebars from "../Sidebar/Sidebars";

const ProtectedRoute = ({
  component: Component,
  role,
  userData,
  onChildData,
  mainId,
  token,
  userDetail,
}) => {
  const [sidebar, setSidebar] = useState(true);
  const [isSidebar, setIsSidebar] = useState(true);
  const location = useLocation();
  const [dateFilter, setDateFilter] = useState("after");
  const [prevPath, setPrevPath] = useState(location.pathname);

  if (location.pathname !== prevPath) {
    const isInspectionRelated = (path) => {
      return path === "/gram-sabha-inspection" || 
             path === "/development-work" || 
             path === "/amrit-sarovar" ||
             path.startsWith("/gram-sabha-inspection/");
    };
    
    if (!(isInspectionRelated(location.pathname) && isInspectionRelated(prevPath))) {
      setDateFilter("after");
    }
    setPrevPath(location.pathname);
  }
  const [designation, setDesignation] = useState([
    "Women representative",
    "Youth member",
    "Backward Class",
    "Physically Challenged",
    "Transgender",
    "Representative of CSO/SHG",
    "Ex. Sarpanch",
    "Other"
  ]);
  const [designationFacilitator, setDesignationFacilitator] = useState([
    "SHG (Self Help Group Member)",
    "CPLO/Village Sahayak (CRID Panchayat Local Operator)",
    "Gram Sachiv",
    "Patwari",
    "Other"
  ]);

  const [department, setDepartment] = useState([
    "Development & Panchayats Department, Haryana",
    "Agriculture and Family Welfare",
    "Health and Family Welfare",
    "Ayush/Ayurveda",
    "Women & Child Department",
    "Haryana Forests Department",
    "Rural Development Department",
    "Department of Animal Husbandry & Dairying",
    "Directorate of Archaeology & Museums",
    "Irrigation & Water Resources Department, Haryana",
    "School Education Department",
    "Public Health Engineering/Drinking Water & Sanitation",
    "Public Works Department",
    "New and Renewable Energy",
    "Department of Industries & Commerce, Haryana",
    "Revenue and Disaster Management Department",
    "Skill Development & Industrial Training Department, Haryana",
    "Electronics & Information Technology Department/ NIC",
    "Haryana Archives Department",
    "Dakshin Haryana Bijli Vitran Nigam",
    "Uttar Haryana Bijli Vitran Nigam",
    "Horticulture Department",
    "Social Justice & Empowerment, Welfare of Scheduled Caste & Backward Classes Department and Antyodaya Department",
    "Other"
  ]);
  const [entityTYpeFacilitator, setEntityTYpeFacilitator] = useState([
    "Gram Panchayat",
    "Block Panchayat",
    "District Panchayat",
  ])
  const [entityType, setEntityType] = useState([
    "Non-Profit Organization",
    "For-Profit Organization",
    "Government",
    "Educational Institution"
  ])
  const [committeName, setCommitteName] = useState([
    "Production Committee",
    "Social justice Committee",
    "Amenities Committee",
    "Local Committee",
    "Any other Committee"

  ]);
  const [memberType, setMemberType] = useState([
    "Member 1",
    "Member 2",
    "Member 3",
    "Member 4",
    "Member 5"

  ]);
  // const [officerTypeOptions, setOfficerTypeOptions] = useState([
  //   "DNO",
  //   "SNO",
  //   "District Panchayat",
  // ])

  const handleSidebar = () => {
    setSidebar(!sidebar);
  };

  const storedToken = sessionStorage.getItem("token");
  if (!storedToken) {
    return <Navigate to="/" replace />;
  }

  const hideDateTabs = [
    "/general-gram-sabha-status-admin",
    "/gram-sabha-meeting",
    "/ceozp-report",
    "/scheme-report",
    "/income-verification-ceo",
    "/development-work",
    "/amrit-sarovar"
  ].includes(location.pathname) || location.pathname.startsWith("/gram-sabha-inspection/");

  return (
    <div className="App">
      {isSidebar ? (
        <>
          <div
            style={{
              display: "grid",
              height: "100vh",
              width: "100%",
              background: "var(--glass)",
              gridTemplateColumns: sidebar ? "220px 1fr" : "60px 1fr",
              overflow: "hidden",
              transition: "grid-template-columns 0.3s ease-in-out",
            }}
          >
            <div style={{ overflow: "hidden" }}>
              <Sidebars
                userData={userData}
                userDetail={userDetail}
                role={role}
                sidebar={sidebar}
              />
            </div>
            <div className="MainDash" style={{ overflow: "auto" }}>
              <Navbar
                userData={userData}
                handleSidebar={handleSidebar}
                sidebar={sidebar}
                isSidebar={isSidebar}
                dateFilter={hideDateTabs ? null : dateFilter}
                setDateFilter={hideDateTabs ? null : setDateFilter}
              />
              <Component
                userData={userData}
                onChildData={onChildData}
                mainId={mainId}
                token={token}
                userDetail={userDetail}
                setIsSidebar={setIsSidebar}
                designationOptions={designation}
                designationFacilitator={designationFacilitator}
                // officerTypeOptions={officerTypeOptions}
                department={department}
                entityTYpeFacilitator={entityTYpeFacilitator}
                entityType={entityType}
                committeName={committeName}
                memberType={memberType}
                dateFilter={dateFilter}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              display: "grid",
              height: "100vh",
              width: "100%",
              background: "var(--glass)",
              overflow: "hidden",
              transition: "grid-template-columns 0.15s ease-in-out",
            }}
          >
            <div className="MainDash" style={{ overflow: "auto" }}>
              <Navbar
                userData={userData}
                handleSidebar={handleSidebar}
                sidebar={sidebar}
                dateFilter={hideDateTabs ? null : dateFilter}
                setDateFilter={hideDateTabs ? null : setDateFilter}
              />
              <Component
                userData={userData}
                onChildData={onChildData}
                mainId={mainId}
                token={token}
                userDetail={userDetail}
                setIsSidebar={setIsSidebar}
                dateFilter={dateFilter}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ProtectedRoute;
